import { CONFIG } from '../config';
import type { SyncEngine } from '../sync/SyncEngine';
import { deviceId } from './monitor';

const bootAt = Date.now();

/**
 * Latido cada 5 minutos hacia /api/heartbeat (Worker de Cloudflare → KV).
 * Si un tótem deja de latir más de 15 min, /api/estado lo marca en rojo.
 */
export function startHeartbeat(sync: SyncEngine, getScreen: () => string) {
  const beat = async () => {
    try {
      const info = await sync.store.info();
      const mem = (performance as unknown as { memory?: { usedJSHeapSize: number; jsHeapSizeLimit: number } }).memory;
      const s = sync.status;
      const body = {
        device: deviceId(),
        app: CONFIG.appVersion,
        content: s.activeVersion,
        pending: s.pendingVersion,
        phase: s.phase,
        lastSuccessAt: s.lastSuccessAt,
        lastError: s.lastError,
        missingLive: s.missingLive,
        screen: getScreen(),
        uptimeMin: Math.round((Date.now() - bootAt) / 60_000),
        storage: info,
        heapMB: mem ? Math.round(mem.usedJSHeapSize / 1e6) : null,
        ua: navigator.userAgent,
        store: sync.store.kind,
      };
      await fetch(CONFIG.heartbeatUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
        keepalive: true,
        cache: 'no-store',
      });
    } catch {
      /* sin red: el siguiente latido lo intentará de nuevo */
    }
  };
  setTimeout(beat, 10_000);
  setInterval(beat, CONFIG.heartbeatMs);
}

export function uptimeHours(): number {
  return (Date.now() - bootAt) / 3_600_000;
}
